/** @format */

import React from 'react';
import NumberFormat from 'react-number-format';

import ImageViewer from '../../../admin/components/image_viewer';
import {capitalize} from 'frontier/ds/quoter/functions/format';
import {
    PRODUCT_TYPE_CARTON,
    PRODUCT_TYPE_GRAPHIC_DESIGN,
    PRODUCT_TYPE_LABEL,
    SIZE_TYPE_CUSTOM_NEW,
    SIZE_TYPE_STANDARD_NEW
} from 'frontier-constants';

export default function OrderMeta(props) {
    const isGraphicDesignOrder = !!props?.isGraphicDesignOrder;
    const valuesWithLabels = Array.isArray(props.values) && typeof props.values[0] === 'object';
    if (props.open) {
        return (
            <div className="mb-4 d-flex justify-content-between bs4 bs4-modal">
                <div>
                    {props.values
                        .filter(value => value !== null)
                        .map((value, idx) => {
                            if (valuesWithLabels) {
                                return (
                                    <React.Fragment key={idx}>
                                        <span className="cart-meta-label">
                                            {capitalize(value.label)}:{' '}
                                        </span>
                                        {value.value}
                                        <br />
                                    </React.Fragment>
                                );
                            } else {
                                return (
                                    <React.Fragment key={idx}>
                                        {typeof value === 'string' && (
                                            <>
                                                {value} <br />
                                            </>
                                        )}
                                    </React.Fragment>
                                );
                            }
                        })}
                    <div>
                        {props.designs &&
                            props.designs.map(design => {
                                return (
                                    <div key={design.id}>
                                        <ImageViewer
                                            src={design.signed_url}
                                            filename={design.filename}>
                                            <button className="btn btn-link text-link tw-p-0 mr-4">
                                                {design.filename}{' '}
                                                <i className="fa fa-eye tw-ml-2" />
                                            </button>
                                        </ImageViewer>
                                        {!isGraphicDesignOrder && (
                                            <span>
                                                <NumberFormat
                                                    value={design.qty}
                                                    thousandSeparator={true}
                                                    displayType="text"
                                                />
                                            </span>
                                        )}
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="text-truncate" style={{cursor: 'pointer'}}>
            {valuesWithLabels
                ? props.values
                      .filter(value => value !== null)
                      .filter(value =>
                          valuesWithLabels
                              ? typeof value.value !== 'undefined' && value.value !== null
                              : true
                      )
                      .map(value => {
                          return valuesWithLabels ? (
                              <span className="cart-meta-item" key={value.label}>
                                  <span className="cart-meta-label">
                                      {capitalize(value.label)}:{' '}
                                  </span>
                                  {value.value}
                              </span>
                          ) : (
                              value
                          );
                      })
                : props.values.filter(value => value !== null).join(', ')}
        </div>
    );
}

// prettify the propduct metadata. Returns properies in an array
//['New Die', 'High Opacity Black', 'Blank Carton', 'Black Ink Only', 'Duplex printing']
export const prettyProductMeta = product => {
    const isLabel = product.product_type_id === PRODUCT_TYPE_LABEL;
    const data = [];

    if (product.product_type_id !== PRODUCT_TYPE_GRAPHIC_DESIGN) {
        product.is_front_back && data.push('Front/ Back Alternating');
        product.has_variable_data && data.push('Variable Data');
        (product.size_type_id === SIZE_TYPE_CUSTOM_NEW ||
            product.size_type_id === SIZE_TYPE_STANDARD_NEW) &&
            data.push('New Die');
        product.is_high_opacity_white && data.push('High Opacity White');
        product.is_high_opacity_black && data.push('High Opacity Black');
        product.is_reverse_print && data.push('Reverse Printing');
        product.is_blank && data.push(`Blank ${isLabel ? 'Label' : 'Carton'}`);
        product.roll_max && data.push(`Max. labels/ diam. per roll ${product.roll_max}`);
        product.color_label && data.push(product.color_label);
        product.is_duplex && data.push('Duplex printing');
        product.is_embossing && data.push(product.embossing_type_label);
    }
    return data;
};
